import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import CouponModal from './CouponModal';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../SearchContext';
import Loader from './Loader';
import { decryptToken } from './utils/getToken';

const Coupon = () => {
    const { isSidebarOpen } = useSidebar();
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const { globalSearch } = useSearch();
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [coupons, setCoupons] = useState([]);
    const [filteredCoupons, setFilteredCoupons] = useState(coupons);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const urlmain = process.env.REACT_APP_LINK
    const [couponform, setCouponForm] = useState({
        Coupon: "",
        percentage_offer: "",
        price_offer: "",
        start: "",
        end: "",
        used_by: "",
        status: "",
        user_id: user.main_id,
        user_name: user.full_name || 'Admin'
    })
    const [load, setLoad] = useState(false);
    const token = decryptToken("accessToken") || ""



    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    // Effect to handle filtering
    useEffect(() => {
        const filtered = coupons.filter((coupon) =>
            Object.values(coupon).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredCoupons(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, coupons]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCoupons.length / itemsPerPage);
    const currentData = filteredCoupons.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status


    const handleDelete = (couponId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to delete this coupon?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${urlmain}/coupon/${couponId}`, {
                        method: 'DELETE',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                    const data = await response.json();

                    if (response.ok) {
                        Swal.fire('Deleted!', data.message, 'success');
                        fetchCoupon(); // Refresh list after delete
                    } else {
                        Swal.fire('Failed', data.message || 'Failed to delete', 'error');
                    }
                } catch (error) {
                    Swal.fire('Error', 'Server error occurred', 'error');
                    console.error(error);
                }
            }
        });
    };

    const toggleStatus = async (id) => {
        try {
            const res = await fetch(`${urlmain}/coupon/toggle-status/${id}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const result = await res.json();

            if (res.ok) {
                toast.success(result.message);
                // fetchCoupon(); // Refresh list
                setCoupons((prev) =>
                    prev.map((coupon) =>
                        coupon.id === id
                            ? { ...coupon, status: coupon.status === 'Active' ? 'Inactive' : 'Active' }
                            : coupon
                    )
                );
            } else {
                toast.error(result.message || "Failed to toggle status");
            }
        } catch (error) {
            toast.error("Server error");
            console.error(error);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setCouponForm((prev) => ({ ...prev, [name]: value }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = couponform.id !== undefined;
        const url = isEdit
            ? `${urlmain}/coupon/change/${couponform.id}`
            : `${urlmain}/coupon/admin1997`;
        const method = isEdit ? 'PUT' : 'POST';

        const payload = {
            Coupon: couponform.Coupon,
            percentage_offer: couponform.percentage_offer || null,
            price_offer: couponform.price_offer || null,
            start_date: couponform.start,
            end_date: couponform.end,
            used_by: couponform.used_by,
            status: couponform.status?.value,
            user_id: user.main_id,
            user_name: user.full_name || 'Admin'
        };

        try {
            const res = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    Coupon: result.Coupon,
                    percentage_offer: result.percentage_offer,
                    price_offer: result.price_offer,
                    start: result.start_date,
                    end: result.end_date,
                    used_by: result.used_by,
                    status: couponform.status?.value,
                    user_id: user.main_id,
                    user_name: user.full_name || 'Admin'
                };


                toast.success(isEdit ? 'Coupon updated' : 'Coupon added');
                fetchCoupon();
                // setCoupons(prev => isEdit
                //     ? prev.map(c => c.id === result.id ? mappedResult : c)
                //     : [...prev, mappedResult]
                // );


                setIsModalOpen(false);
                setCouponForm({
                    Coupon: "",
                    percentage_offer: "",
                    price_offer: "",
                    start: "",
                    end: "",
                    used_by: "",
                    status: "",
                    user_id: user.main_id,
                    user_name: user.full_name || 'Admin'
                });
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err.message);
        }
    };


    const fetchCoupon = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${urlmain}/coupon/${user.main_id}`);
            const res = await response.json();
            console.log(res);
            setCoupons(res);
            setFilteredCoupons(res);
        } catch (error) {
            console.log(error);
        } finally {
            setLoad(false)
        }
    };


    useEffect(() => {
        fetchCoupon();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }

    return (
        <>

            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Coupon</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setCouponForm({
                            Coupon: "",
                            percentage_offer: "",
                            price_offer: "",
                            start: "",
                            end: "",
                            used_by: "",
                            status: "",
                            user_id: user.main_id,
                            user_name: user.full_name || 'Admin'
                        });
                    }}>
                        Add coupon
                    </button>
                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

                {/* Customer Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Coupon</th>
                                <th>Discount (%)</th>
                                <th>Price Discount</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Usage</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>{customer.Coupon}</td>
                                        <td>{customer.percentage_offer || "-"}%</td>
                                        <td>{customer.price_offer || "-"}</td>
                                        <td>{customer.start_date || "-"}</td>
                                        <td>{customer.end_date || "-"}</td>
                                        <td>{customer.used_by || "-"}</td>
                                        <td>
                                            <button
                                                className={`status-toggle ${customer.status ? 'Active' : 'Inactive'}`}
                                                onClick={() => toggleStatus(customer.id)}

                                            >
                                                {customer.status === "Active" ? (
                                                    <i className="fas fa-toggle-on"></i> // Active
                                                ) : (
                                                    <i className="fas fa-toggle-off"></i> // Inactive
                                                )}
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setCouponForm({
                                                        id: customer.id, // include ID for PUT request
                                                        Coupon: customer.Coupon,
                                                        percentage_offer: customer.percentage_offer || "",
                                                        price_offer: customer.price_offer || "",
                                                        start: customer.start,
                                                        end: customer.end,
                                                        used_by: customer.used_by,
                                                        status: statusOptions.find(
                                                            opt => opt.value.toLowerCase() === (customer.status || '').toLowerCase()
                                                        ) || null,
                                                        user_id: user.main_id,
                                                        user_name: user.full_name || 'Admin'
                                                    });
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(customer.id)}

                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>No coupons found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ecom-responsive-cards">
                    {currentData.length === 0 ? (
                        <p style={{ textAlign: "center", margin: "50px" }}>No Coupons Added</p>
                    ) : (
                        currentData.map((group, index) => (
                            <div className="ecom-responsive-card" key={index}>
                                <div className="ecom-responsive-header">
                                    <div className='p-toggle'>
                                        <p onClick={() => {
                                            setCouponForm({
                                                id: group.id, // include ID for PUT request
                                                Coupon: group.Coupon,
                                                percentage_offer: group.percentage_offer || "",
                                                price_offer: group.price_offer || "",
                                                start: group.start_date,
                                                end: group.end_date,
                                                used_by: group.used_by,
                                                status: statusOptions.find(
                                                    opt => opt.value === (group.status || '')
                                                ) || null,
                                                user_id: user.main_id,
                                                user_name: user.full_name || 'Admin'
                                            });
                                            setIsModalOpen(true);
                                        }}>
                                            <Pencil size={20} style={{ marginRight: 4 }} /> <span>Edit</span>
                                        </p>

                                        <button
                                            className={`status-toggle ${group.status === "Active" ? 'Active' : 'Inactive'}`}
                                            onClick={() => toggleStatus(group.id, group.status)}
                                        >
                                            {group.status === "Active" ? (
                                                <>
                                                    <LucideToggleRight style={{ marginRight: 4 }} />
                                                    <span>Active</span>
                                                </>
                                            ) : (
                                                <>
                                                    <LucideToggleLeft style={{ marginRight: 4 }} />
                                                    <span>Inactive</span>
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <p onClick={() => handleDelete(group.id)}>
                                        <Trash2 size={20} style={{ marginRight: 4 }} /> <span>Delete</span>
                                    </p>
                                </div>

                                <div className="ecom-responsive-body">
                                    <div className="ecom-responsive-left">
                                        <h2>
                                            {group.Coupon || "Not Provided"} (
                                            {group.percentage_offer
                                                ? `${group.percentage_offer}%`
                                                : group.price_offer
                                                    ? `₹${group.price_offer}`
                                                    : "N/A"} Off)
                                        </h2>
                                        <p>Start date: {group.start_date} || End date: {group.end_date}</p>
                                        <p>Coupon Usage: {group.used_by}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}

            </div>

            <CouponModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={couponform}
                setCouponForm={setCouponForm}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
            />
        </>
    );
};

export default Coupon;
